<template>
  <div>
    <span>
      <b-button v-on:click="addInfo()" size="sm" variant="outline-light">
        <Icon
          icon="gravity-ui:picture"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="'Resim Ekle'"
          color="#28C76F"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="removeInfo()" size="sm" variant="outline-light">
        <Icon
          icon="mdi:remove"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="'Resim Sil'"
          color="#EA5455"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default { 
  components: { Icon },
  methods: {
    addInfo() { 
      this.$root.$emit("stockDetail", this.params.data);
    },
    removeInfo() { 
      this.$root.$emit("pictureRemove", this.params.data);
    },
  },
};
</script>
